// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data_set_container {
  display: inline-block;
  max-height: 100%;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/core/dialog/loaded-dataset/loaded-dataset.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;AACF","sourcesContent":[".data_set_container {\r\n  display: inline-block;\r\n  max-height: 100%;\r\n  overflow: hidden;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
